"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("../../Display/Icon"));
var _Count = _interopRequireDefault(require("./conponents/Count"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Pager = function Pager(props) {
  var id = props.id,
    className = props.className,
    style = props.style,
    countRight = props.countRight,
    disabled = props.disabled,
    hideCount = props.hideCount,
    onNextClick = props.onNextClick,
    onPrevClick = props.onPrevClick,
    _props$paging = props.paging,
    current_page = _props$paging.current_page,
    next_page = _props$paging.next_page,
    prev_page = _props$paging.prev_page,
    per = _props$paging.per,
    total_count = _props$paging.total_count;
  var prevBtnLabel = 'Previous Page';
  var nextBtnLabel = 'Next Page';
  var pagerContainerClass = function pagerContainerClass() {
    return (0, _classnames["default"])({
      'ui-pager': true
    }, className);
  };
  var actionsClass = function actionsClass() {
    return (0, _classnames["default"])({
      'ui-pager__actions': true,
      'ui-pager__actions--left': !countRight,
      'ui-pager__actions--right': countRight
    });
  };
  var nextBtnClass = function nextBtnClass() {
    return (0, _classnames["default"])({
      'ui-pager__btn': true,
      'ui-pager__btn-next': true,
      'ui-pager__btn--disabled': !next_page || disabled
    });
  };
  var prevBtnClass = function prevBtnClass() {
    return (0, _classnames["default"])({
      'ui-pager__btn': true,
      'ui-pager__btn-prev': true,
      'ui-pager__btn--disabled': !prev_page || disabled
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: pagerContainerClass(),
    style: style
  }, !hideCount && !countRight && /*#__PURE__*/_react["default"].createElement(_Count["default"], {
    currentPage: current_page,
    per: per,
    totalCount: total_count
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: actionsClass()
  }, /*#__PURE__*/_react["default"].createElement("button", {
    tabIndex: 0,
    className: prevBtnClass(),
    id: id,
    "aria-label": prevBtnLabel,
    disabled: !prev_page || disabled,
    onClick: onPrevClick,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "IconCaretLeft",
    size: 10
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Previous Page")), /*#__PURE__*/_react["default"].createElement("button", {
    tabIndex: 0,
    className: nextBtnClass(),
    id: id,
    "aria-label": nextBtnLabel,
    disabled: !next_page || disabled,
    onClick: onNextClick,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "IconCaretRight",
    size: 10
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Next Page"))), !hideCount && countRight && /*#__PURE__*/_react["default"].createElement(_Count["default"], {
    currentPage: current_page,
    per: per,
    totalCount: total_count
  }));
};
Pager.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,
  /** className for reference */
  className: _propTypes["default"].string,
  /** If true, pagination counter is on the right. */
  countRight: _propTypes["default"].bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,
  /** If true, buttons are disabled. */
  disabled: _propTypes["default"].bool.isRequired,
  /** If true, pagination counter is hidden. */
  hideCount: _propTypes["default"].bool,
  /** Callback function when the next button is clicked */
  onNextClick: _propTypes["default"].func.isRequired,
  /** Callback function when the previous button is clicked */
  onPrevClick: _propTypes["default"].func.isRequired,
  /** paging object with paginatin information */
  paging: _propTypes["default"].object.isRequired
};
Pager.defaultProps = {
  id: '',
  className: '',
  countRight: false,
  disabled: false,
  hideCount: false,
  style: {}
};
var _default = exports["default"] = Pager;